import React, { useEffect } from 'react';
import confetti from 'canvas-confetti';

const SuccessCelebration = ({ type = 'blog' }) => {
    useEffect(() => {
        if (type === 'blog') {
            // Emerald themed burst for blogs
            const duration = 3 * 1000;
            const animationEnd = Date.now() + duration;
            const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };

            const randomInRange = (min, max) => Math.random() * (max - min) + min;

            const interval = setInterval(function() {
                const timeLeft = animationEnd - Date.now();

                if (timeLeft <= 0) {
                    return clearInterval(interval);
                }

                const particleCount = 50 * (timeLeft / duration);
                
                // since particles fall down, start a bit higher than random
                confetti({
                    ...defaults,
                    particleCount,
                    origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
                    colors: ['#10E58F', '#34d399', '#6ee7b7']
                });
                confetti({
                    ...defaults,
                    particleCount,
                    origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
                    colors: ['#10E58F', '#34d399', '#6ee7b7']
                });
            }, 250);
        } else if (type === 'interview') {
            // Gold and Indigo themed burst for interview success
            const count = 200;
            const defaults = {
                origin: { y: 0.7 }
            };

            function fire(particleRatio, opts) {
                confetti({
                    ...defaults,
                    ...opts,
                    particleCount: Math.floor(count * particleRatio)
                });
            }

            fire(0.25, {
                spread: 26,
                startVelocity: 55,
                colors: ['#6366f1', '#4338ca', '#f59e0b', '#fbbf24']
            });
            fire(0.2, {
                spread: 60,
                colors: ['#6366f1', '#fbbf24']
            });
            fire(0.35, {
                spread: 100,
                decay: 0.91,
                scalar: 0.8,
                colors: ['#4338ca', '#f59e0b']
            });
            fire(0.1, {
                spread: 120,
                startVelocity: 25,
                decay: 0.92,
                scalar: 1.2,
                colors: ['#fbbf24', '#ffffff']
            });
            fire(0.1, {
                spread: 120,
                startVelocity: 45,
                colors: ['#6366f1', '#ffffff']
            });
        }
    }, [type]);

    return null; // Side-effect only component
};

export default SuccessCelebration;
